// Module
var code = `<div class="form-group {{form.htmlClass}} schema-form-select"
     ng-class="{
        'has-error': form.disableErrorState !== true && hasError(),
        'has-success': form.disableSuccessState !== true && hasSuccess(),
        'has-feedback': form.feedback !== false
        }"
>
    <label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">
        {{form.title}}
    </label>
    <div class="{{form.fieldHtmlClass}}">
        <ui-select multiple
                   sf-field-model
                   remove-selected="false"
                   limit="{{form.maxItems}}"
                   class="form-control"
        >
            <ui-select-match placeholder="{{form.placeholder}}">
                {{\$item.name}}
            </ui-select-match>

            <ui-select-choices repeat="item.value as item in form.titleMap | filter: \$select.search">
                <div ng-bind-html="item.name | highlight: \$select.search"></div>
            </ui-select-choices>
            <ui-select-no-choice>
                We couldn't find any choices...
            </ui-select-no-choice>

        </ui-select>
    </div>
    <div class="help-block" sf-message="form.description"></div>
</div>
`;
// Exports
module.exports = code;